module.exports = __webpack_public_path__ + "static/media/Logo.5161040b.png";